import { darken } from '@mui/material'

const styles = {
  ctaModal: {
    width: '100%',
    mb: 2,
    p: 1.5,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '18px',
  },
  body: {
    textAlign: 'center',
    mb: 2,
  },
  ctaSeeOffer: {
    mt: 1,
    color: 'white!important',
    backgroundColor: 'highlight.main',
    paddingY: 1.5,
    border: 1,
    '&:hover': {
      backgroundColor: darken('#E3007D', 0.1),
    },
  },
  seeOfferCancelCta: {
    backgroundColor: 'none',
    color: 'text.primaryDark',
    borderStyle: 'solid',
    borderColor: '#E9E9E9',
    fontSize: 14,
  },
}

export default styles
